import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96ffb9ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "zoomImage",
  tabindex: "-1",
  "aria-labelledby": "zoomImage",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end mb-4 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "fit_img" }
const _hoisted_6 = ["src"]

import { POST_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const zoom_image = computed<string>(() => store.getters[POST_STORE.GETTERS.ZOOM_IMAGE])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _unref(zoom_image),
            alt: "post image23",
            class: "img-url w-100 h-100 mb-4 object-fit-contain"
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ]))
}
}

})